import isUnknownObject from './isUnknownObject';
import NodeTypes from './NodeTypes';
/**
 * Returns whether provided node is an HTML document.
 */

export default function isDocument(node) {
  return isUnknownObject(node) && node.nodeType === NodeTypes.DOCUMENT_NODE;
}
//# sourceMappingURL=isDocument.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/isDocument.js
// module id = 41
// module chunks = 0 1